<div id="map"></div>
<div id='error-message'></div>